import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  input,
  output,
  signal,
  ViewChild
} from '@angular/core';

import { PopulateAnalytics } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  PredictiveSearch,
  RecentListItem
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { GenericAction, SelectedData, Tab } from '@com-delta-omnichannel/mach';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes
} from '../../constants/book-widget.constants';
import { BookWidgetAem } from '../../models/book-widget-aem.interfaces';
import { BookWidgetFieldUpdateEvent } from '../../models/book-widget-fields-update-info.interfaces';
import { BookWidgetFields } from '../../models/book-widget-fields.interfaces';
import { DatepickerConfig } from '../../models/common.interfaces';
import {
  SearchModalEvent,
  SearchModalEventType
} from '../../models/search-modal-events-object.interface';
import { InfoPopUpModalComponent } from '../common/info-popup-modal/info-popup-modal.component';
import { ModifyBookWidgetExtendedComponent } from './modify-book-widget.extended';
import { ModifyBookWidgetImports } from './modify-book-widget.imports';
@Component({
  standalone: true,
  selector: 'idp-modify-book-widget',
  templateUrl: './modify-book-widget.component.html',
  styleUrls: ['./modify-book-widget.component.scss'],
  imports: ModifyBookWidgetImports,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModifyBookingWidgetComponent extends ModifyBookWidgetExtendedComponent {
  isDesktop = input(false);
  isBookWidgetReady = input(false);
  bookWidgetFields = input<BookWidgetFields>();
  bookWidgetAem = input<BookWidgetAem | null>();
  searchModalTabs = input<Tab[]>([]);
  recentSearchList = input<RecentListItem[]>([]);
  savedSearchList = input<string[]>([]);
  datepickerConfig = input<DatepickerConfig>({} as DatepickerConfig);
  predictiveSearchList = input<GenericAction[]>([]);
  guidedNavigationErrorMsg = input<string | null>();

  analyticsEvent = output<PopulateAnalytics>();
  bookWidgetFieldChange = output<BookWidgetFieldUpdateEvent>();
  findFlight = output<void>();
  swapAirports = output<number>();
  addFlightsForMc = output<void>();
  removeFlightForMc = output<void>();
  searchModalEvent = output<SearchModalEvent<SearchModalEventType>>();
  routePickerClicked = output<SelectedData>();
  viewSearchOptionEvent = output<void>();

  @ViewChild('infoPopUpModal') infoPopUpModal!: InfoPopUpModalComponent;
  isAdvancedSearchExpanded = signal(true);

  protected predictiveSearchData = computed<PredictiveSearch>(() => ({
    ...this.predictiveSearchConfig(),
    items: this.predictiveSearchList()
  }));

  constructor(private elementRef: ElementRef) {
    super();
    effect(() => {
      if (this.guidedNavigationErrorMsg()) {
        this.setAdvancedSearchExpandedStatus();
      }
    });
  }

  setAdvancedSearchExpandedStatus() {
    if (
      this.bookWidgetFields()?.meetingEventCodeField.fieldErrorInfo
        ?.errorMessage
    ) {
      this.isAdvancedSearchExpanded.set(true);
    }
  }

  infoIconClickHandler(event: BookWidgetFieldInfoTypes) {
    this.getToolTipContent(event);
    this.showDialog.set(true);
  }

  getToolTipContent(event: BookWidgetFieldInfoTypes) {
    const aem = this.bookWidgetAem();
    aem &&
      this.infoPopUpModalData.update((prev) => ({
        ...prev,
        title: aem[event]?.infoModal.title || '',
        description: aem[event]?.infoModal.description || ''
      }));
  }

  closeModal() {
    this.showDialog.set(false);
  }

  bookWidgetFieldChangeHandler(event: BookWidgetFieldUpdateEvent) {
    this.bookWidgetFieldChange.emit(event);
    if (event.type === BookWidgetFieldUpdateTypes.tripType) {
      setTimeout(() => {
        const element =
          this.elementRef.nativeElement.querySelector('#trip-type-field');
        element?.focus();
      });
    }
  }

  handleModalTriggerClicked(event: SelectedData) {
    const aem = this.bookWidgetAem();
    this.predictiveSearchConfig.update((prev) => ({
      ...prev,
      placeholder: this.preparePlaceholderText(event.type, aem),
      value: event.selectedResult.cityCode,
      errorMessage: aem?.errorMessages['SBW015'].message,
      selectLabel: aem?.airportsField.searchModal.selectLabel
    }));
  }

  toggleAdvSearchExpanded() {
    this.isAdvancedSearchExpanded.update((v) => !v);
  }

  onViewSearchOptionsHandler() {
    this.viewSearchOptionEvent.emit();
  }

  findFlightClickHandler() {
    this.findFlight.emit();
  }
}
